export default {
  TITLE: `Capacité d'horaire`,
  POSITION: `Position`,
  LAST_UPDATED: `Mise à jour {{date}}`,
  NO_DATA_LOADED: `Rien à afficher`,
  ERROR_LOADING: `Erreur en téléchargeant les données`,
  LOAD: `Actualiser`,
  ADD_ONE_MONTH: `Ajouter un mois`,
  FORCE_RELOAD: `Forcer le renouvellement`,
  PLANNED: 'Quarts de travail prévus',
  PRIMARY_CAPACITY: 'Capacité primaire',
  REMAINING_CAPACITY: 'Capacité restante',
  PRIMARY_DELTA: 'Delta primaire',
  TOTAL_DELTA: 'Delta total',
  START_DATE_AFTER_END: `La date de début doit être avant la date de fin.`,
  DETAIL_MODAL: {
    TITLE: `Détail de la capacité d'horaire`,
    SUMMARY: ``,
    ERROR_LOADING: `Erreur en chargeant les employés à l'horaire.`,
    PRIMARY_SCHEDULED: `Capacité primaire à l'horaire ({{ count }})`,
    PRIMARY_UNSCHEDULED: `Capacité primaire n'étant pas à l'horaire  ({{ count }})`,
    TOTAL_SCHEDULED: `Capacité totale à l'horaire  ({{ count }})`,
    TOTAL_UNSCHEDULED: `Capacité totale n'étant pas à l'horaire  ({{ count }})`
  },
  filter: {
    START_DATE: `Date de début`,
    END_DATE: `Date de fin`,
    POSITIONS: `Positions`,
    REGION: `Région`,
    SCHEDULE_TYPE: `Type d'horaire`,
    ALL: `Tous`
  },
  progress: {
    CALCULATING_ATTRIBUTE_MATRICES: `Calcul des matrices d'attribut`,
    CALCULATING_AVAILABILITY: 'Calcul de la disponibilité',
    SAVING_CAPACITY: 'Enregistrement dans la base de données',
    DONE: 'Fini'
  },
  export: {
    TITLE: `Exporter`,
    EXPORT_CSV: `Exporter en CSV`,
    EXPORT_CSV_DETAILED: `Exporter en CSV (détaillé)`,
    EXPORT_CSV_SECONDARY_DETAIL: `Exporter en CSV (assignations secondaires)`,
    EXPORT_CSV_AVAILABILITY: `Exporter en CSV (disponibilités)`,
    EXPORT_CSV_UNSCHEDULED_BUT_ELIGIBLE: `Exporter en CSV (non prévu à l'horaire mais éligible)`
  },
  csv: {
    CSV_DEFAULT_NAME: `export_capacité_horaire_{{ start }}_{{end}}`,
    CSV_AVAILABILITY_NAME: `export_capacité_horaire_disponibilites_{{ start }}_{{end}}`,
    CSV_DETAILED_NAME: `export_capacité_horaire_detaille_{{ start }}_{{end}}`,
    CSV_DETAILED_SECONDARY_NAME: `export_capacité_horaire_detaille_secondaire_{{ start }}_{{end}}`,
    CSV_UNSCHEDULED_BUT_AVAILABLE_NAME: `export_capacité_horaire_disponible_pas_a_lhoraire_{{ start }}_{{end}}`,
    NOT_ELIGIBLE: `Non éligible`,
    NOT_AVAILABLE_REPORT: `Non disponible`,
    PREFERED_TIME: `Préfère`,
    AVAILABLE_TIME: `Disponible`,
    UNAVAILABLE: `Non disponible`,
    AVAILABLE_ALL_DAY: `Disponible`
  }
}
